import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

const getUserCart = async () => {
  try {
    const token = getAuthToken();
    const data = await api.get("/cart", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const addItemToCart = async (productId, quantity) => {
  // console.log("product id from services", productId);
  // console.log("quantity from services", quantity);
  try {
    const token = getAuthToken();
    const data = await api.post(
      `/cart`,
      {
        productId,
        count: quantity,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (err) {
    throw err;
  }
};

const removeItemFromCart = async (productId) => {
  try {
    const token = getAuthToken();
    const data = await api.delete(`/cart/${productId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const updateCartItemQuantity = async (productId, quantity) => {
  try {
    const token = getAuthToken();
    const data = await api.put(
      `/cart/${productId}/quantity`,
      {
        quantity,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (err) {
    throw err;
  }
};

const clearCart = async () => {
  try {
    const token = getAuthToken();
    const data = await api.delete("/cart", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};
export {
  getUserCart,
  addItemToCart,
  removeItemFromCart,
  updateCartItemQuantity,
  clearCart,
};
